<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.11037 1.99499L11.4227 6.00001L9.11037 10.005L2.88965 10.005L0.577366 6.00001L2.88965 1.99499L9.11037 1.99499Z" stroke="currentColor"/>
</svg>
